module.exports = __webpack_public_path__ + "static/media/MTL_SL_PP.d1eb71cd.png";